import { ApiError } from '../../api/client'

/**
 * The server's own words. A validation 400 says only "Request validation
 * failed" and puts the reasons in `fields` (the global error handler), so the
 * reasons are what is shown; a route's own 400 (e.g. a past date) carries its
 * message directly.
 */
export function errorMessage(error: unknown): string {
  if (!(error instanceof ApiError) || error.status === 0) {
    return 'Could not reach the server. Check the connection and try again.'
  }
  const fields = error.details.fields
  if (fields && typeof fields === 'object') {
    const reasons = Object.values(fields as Record<string, unknown>).filter(
      (v): v is string => typeof v === 'string',
    )
    if (reasons.length > 0) return reasons.join(' ')
  }
  return error.message
}

/** Retry a failed read (a dropped connection), but never a 403: a caller who
 * may not see this page should be told so at once, not after three retries. */
export function retryUnlessForbidden(
  failures: number,
  error: unknown,
): boolean {
  if (
    error instanceof ApiError &&
    (error.status === 403 || error.status === 401)
  ) {
    return false
  }
  return failures < 3
}
